import {Button, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import {LoadingButton} from "@/components/common/LoadingButton";
import {dialogClose} from "@/modules/MuiDialog";
import {useForm} from "react-hook-form";
import {validateEmail} from "@/utils/validator";
import {toast} from "react-toastify";
import {sendPasswordResetMail} from "@/services/auth.service";
import DialogTitleBox from "@/modules/MuiDialog/DialogTitleBox";

const ResetPassword = ({email}: {email?:string}) => {
    const {register, reset, handleSubmit, formState: {isValid, isDirty, isSubmitting}} = useForm<{
        email: string,
    }>({
        defaultValues: {
            email: email || '',
        }
    })

    async function formSubmit(data: {email:string}) {
        try {
            const {email} = data;
            if (!email) return false;

            await sendPasswordResetMail(email);
            toast.success('비밀번호 재전송 메일이 발송됐습니다.');
            reset();

            dialogClose();
        } catch (e:any) {
            if (!!e.data?.placeHolder) {
                toast.error(e.data?.placeHolder);
            } else {
                toast.error('메일 전송에 실패했습니다. 다시 시도해주세요.');
                console.error(e);
            }
        }
    }

    return (
        <>
            {/* <DialogTitle>비밀번호 찾기/재설정</DialogTitle> */}
            <DialogTitleBox title="비밀번호 찾기/재설정"/>
            <DialogContent>
                <p className={'mb-2'}>로그인 할 계정으로 사용된 이메일 주소를 입력해주세요. 비밀번호를 재설정 할 수 있는 이메일이 전달됩니다.</p>
                <form onSubmit={handleSubmit(formSubmit)}>
                    <TextField label={'이메일(계정)'} {...register('email', {
                        validate: (v, fv) => {
                            v = v || '';
                            return validateEmail(v);
                        }
                    })} fullWidth />
                </form>
            </DialogContent>
            <DialogActions>
                <LoadingButton variant="contained" isLoading={isSubmitting}
                               onClick={() => {
                                   handleSubmit(formSubmit)()
                               }}
                               disabled={!isValid}>
                    재설정 메일 전송하기
                </LoadingButton>
                <Button variant="outlined" color={'error'} onClick={() => {
                    dialogClose();
                }}>취소</Button>
            </DialogActions>
        </>
    )
}

export default ResetPassword;